// extracted by mini-css-extract-plugin
export default {"userId":"StaffSelect_userId__jhBMz","userType":"StaffSelect_userType__-mJ0A"};